/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState, useCallback } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import TableLoader from '../../../../components/TableLoader';
import Modal from '../../../../components/Modal';
import { Container } from './styles';
import DownLoadFile from '../../../../utils/DownLoadFile';
import ConverArrayBufferToData from '../../../../utils/ConverArrayBufferToData';
import Input from '../../../../components/Input';
import { useToast } from '../../../../hooks/toast';
import TicketService from '../../../../services/ticket';
import getValidationErrors from '../../../../utils/getValidationErrors';

interface ConfirmationModalProps {
  cardNumber: string;
  dataBloqueio: string;
  name: string;
  show: boolean;
  title: string;
  text: string;
  handleClose(): void;
  handleSuccess(): void;
}

const ModalDuplicateLetter: React.FC<ConfirmationModalProps> = ({
  cardNumber,
  dataBloqueio,
  name,
  show,
  handleClose,
  handleSuccess,
  title,
  text,
}) => {
  console.log({ handleSuccess });
  const formRef = useRef<FormHandles>(null);
  const services = { TicketService: new TicketService() };
  const [loading, setLoading] = useState(false);
  const [duplicateLetter, setDuplicateLetter] = useState(false);
  console.log({ duplicateLetter });
  const { addToast } = useToast();

  const schema = Yup.object().shape({
    name: Yup.string().required('Digite o nome do responsável pelo bloqueio'),
  });

  const handleDuplicateLetter = useCallback(async (data: any) => {
    try {
      if (!name) {
        formRef.current?.setErrors({});
        await schema.validate(data, {
          abortEarly: false,
        });
      }
      setLoading(true);
      const response = await services.TicketService.getDuplicateLetter(
        cardNumber,
        dataBloqueio,
        name || data.name,
      );
      setDuplicateLetter(response.data);
      DownLoadFile(response.data, 'carta.pdf');
      setLoading(false);
      handleClose();
    } catch (err: any) {
      setLoading(false);
      const { ...error } = err;
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
        return;
      }
      const errorResponse = ConverArrayBufferToData(error.response.data);
      if (errorResponse.Summary.ErrorCollection.SystemFailureErros.length) {
        addToast({
          type: 'error',
          title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possivel executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);

  return (
    <Container>
      <Modal title={title} handleClose={handleClose} show={show}>
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <p className="bodyText">{text}</p>
            <p className="text">
              Deseja emitir a carta de autorização de retirada?
            </p>
            <Form ref={formRef} onSubmit={handleDuplicateLetter}>
              {!name && (
                <>
                  <p className="text">
                    Nome do responsável pelo pedido de bloqueio:
                  </p>
                  <Input name="name" type="text" schema={schema} />
                </>
              )}
              <div className="buttonsContainer">
                <button className="no" type="submit" onClick={handleClose}>
                  NÃO
                </button>
                <button className="button" type="submit">
                  EMITIR
                </button>
              </div>
            </Form>
          </>
        )}
      </Modal>
    </Container>
  );
};

export default ModalDuplicateLetter;
